module.exports = __webpack_public_path__ + "img/inconnue-pertuze.e5c84b85.jpg";